import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from './Service/data.service';
import { MainService } from './Service/main.service';

@Injectable()
export class DashboardGuard implements CanActivate {

	constructor(
		private dataService: DataService,
		router: Router,
		private mainService: MainService,
		private route: Router
	) {

	}
	/**
	 * This function authenticate user before navigate to dashboard.
	 * @param next
	 * @param state
	 */
	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

		const userToken = this.dataService.getUserToken();
		if (!userToken) {
			this.route.navigate(['/login']);
			return false;
		}
	}
}
